import { render, staticRenderFns } from "./appointDetail.vue?vue&type=template&id=1be6e71f&scoped=true&"
import script from "./appointDetail.vue?vue&type=script&lang=js&"
export * from "./appointDetail.vue?vue&type=script&lang=js&"
import style0 from "./appointDetail.vue?vue&type=style&index=0&id=1be6e71f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be6e71f",
  null
  
)

export default component.exports